<template src="./registration.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format } from 'date-fns'

export default {
  name: "aggregatorRegister",
  data() {
    return {
      fileUrl: `${process.env.VUE_APP_API_URL}/file`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('srAccessToken')}`,
        'Access-Control-Allow-Origin': '*',
      },
      ko : ko,
      object : {
        name : null,
        display_name : null,
        email : null,
        contact_phone : null,
        contact_name : null,
        active : true,
        memo : null,
      },

      accept:"",
      extensions:'',
      multiple: false,
      directory: false,
      drop: true,
      dropDirectory: true,
      addIndex: false,
      thread: 3,
      name: 'file',
      uploadAuto: false,

      files1 : [],          // 파일 데이터
      files2 : [],
      files3 : [],

      file1: {
        id :null,
        remote_path : ''
      },// profile
      file2: {
        id :null,
        remote_path : ''
      },
    }
  },
  mounted(){
    this.getGenreList()
    this.$nextTick(function(){
      
    })
  },
  computed: {
      
  },
  watch:{
     
  },
  methods: {
      
    inputFileUpload1(newFile, oldFile) {
      if (newFile && !oldFile) {
        
        this.loadingShow()
        let file = newFile.file
        let reader = new FileReader
        reader.onload = e => {
          console.log(e)
          this.file1.remote_path = e.target.result
          this.$refs.upload1.active = true
        }
        reader.readAsDataURL(file)
      }
      if (newFile && oldFile) {
        // update
        if(Array.isArray(newFile.response)){
          
          this.file1 ={
            ...this.file1,
            id : newFile.response[0].id,
            display_name: newFile.response[0].display_name

          }
          console.log(this.file1)
          this.loadingHide()
        }
        
      }
      if (!newFile && oldFile) {
        // remove
        this.loadingHide()
        console.log('remove', oldFile)
      }
    },
    inputFileUpload2(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        
        this.loadingShow()
        let file = newFile.file
        let reader = new FileReader
        reader.onload = e => {
          this.file2.remote_path = e.target.result
          console.log(e)
          
          this.$refs.upload2.active = true
        }
        reader.readAsDataURL(file)
      }
      if (newFile && oldFile) {
        // update
        console.log(newFile)
        if(Array.isArray(newFile.response)){
          this.file2 ={
            ...this.file2,
            id : newFile.response[0].id, 
            display_name: newFile.response[0].display_name
          }
          
          this.loadingHide()
        }
        
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },

    all_save(){
      let payload = {
          active: this.object.active,
          contact_name: this.object.contact_name,
          contact_phone: this.object.contact_phone,
          email: this.object.email,
          memo: this.object.memo,
          name: this.object.name,
          display_name: this.object.display_name,
          bizregistration_id :  this.file1.id 
      }
      if(!payload.email) {
        delete payload.email
      }
      if(!payload.display_name) {
        delete payload.display_name
      }
      if(!payload.name) {
        delete payload.name
      }
      if(!payload.contact_name) {
        delete payload.contact_name
      }
      this.loadingShow()

      this.$store.dispatch('POST_AGGREGATOR', payload)
        .then(result =>{
            this.noti('저장되었습니다.')
            
            this.$router.push('/aggregator')
            this.loadingHide();
        }).catch(error=>{
          this.loadingHide();
          const status = error.status
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error})
              break;
          }
      })
    }
  },
    
}
</script>

<style scoped>

</style>